import React from "react";
import { SettingsWrapperPresentation } from "./SettingsWrapper.presentation";
import { useLogout } from "../../../utils/logout";

export const SettingsWrapper = () => {
  const handleLogout = useLogout();
  return <SettingsWrapperPresentation onLogout={handleLogout} />;
};
